import { FCT } from '@/i18n';

export const ACTION_CLASSES = {
  CREATE: 'text-green-500 dark:text-green-500',
  DELETE: 'text-red-500 dark:text-red-500 line-through',
  UPDATE: 'text-blue-500 dark:text-blue-500',
};

export type ActionClass = keyof typeof ACTION_CLASSES;

export const IGNORED_FIELDS = [
  'template',
  'uuid',
  'createdAt',
  'createdBy',
  'lastModifiedAt',
  'clinicalNotes',
  'lastModifiedBy',
  'templateUuid',
  'reportUuid',
  'reportFindingsUuids',
  'publishedAt',
  'publishedBy',
  'report',
  'authors',
  'studyId',
  'excludeDicomImages',
  'observation',
  'additionalRecommendations',
  'reportFindings',
  'clinicalNotes',
  'renderedSummaryUuid',
  'userSession',
  'verifyHash',
];

export const ACTIVITY_LOG_DEFAULT_VALUES = {
  false: FCT.ACTIVITY_LOGS.NO_LABEL,
  no_previous: FCT.ACTIVITY_LOGS.NO_PREVIOUS_LABEL,
  true: FCT.ACTIVITY_LOGS.YES_LABEL,
};

export const EDITOR_FIELDS = [
  'descriptionOfCall',
  'techniqueNotes',
  'actionDetails',
  'actionSummary',
  'findingDetails',
  'findingSummary',
  'finalImpressions',
];
